<template>
  <div style="width: 100%;" v-loading.body="loading">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          TRIAL BALANCE REPORTING
        </el-row>
      </el-col>
      <el-col class="small">
        <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button plain @click="generateReport" :disabled="disableReportRun">
            Run report
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Saved Report Options
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedOption" :filterable="true" @change="handleSelection" data-fieldtype="select" :multiple="false" clearable placeholder="Search">
            <el-option
              v-for="opt in savedReportOptions"
              :key="opt.id"
              :label="opt.report_name"
              :value="opt.id">
            </el-option>
          </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Options
      </el-col>
      <el-col :span="20">
        <el-button @click="openSaveOption">Save Report Options</el-button>
        <el-button @click="loadOptions">Load Report Options</el-button>
        <el-button @click="deleteOptions">Delete Report Options</el-button>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.3em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Format
      </el-col>
      <el-col :span="20">
        <el-radio-group v-model="reportOptions.type" @change="updateReportType">
          <el-radio-button label="summary">Basic</el-radio-button>
          <el-radio-button label="detail">Standard</el-radio-button>
          <!-- <el-radio-button label="detail_drcr">Accounting</el-radio-button> -->
        </el-radio-group>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Periods/Dates
      </el-col>
      <el-col :span="21">
        <el-radio-group v-model="reportOptions.dates" @change="updateReportDates">
          <el-radio-button label="datesAll">All</el-radio-button>
          <el-radio-button label="datesPeriod">Period</el-radio-button>
          <el-radio-button label="datesPosted">Posting Date</el-radio-button>
          <el-radio-button label="datesEffective">Effective Date</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>

    <div v-if="reportOptions.dates==='datesPeriod'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">Starting Period</el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">Ending Period</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.period_start" :multiple="false" placeholder="First Period">
            <el-option
              v-for="opt in allCodes.periods"
              :key="opt.id"
              :label="opt.id + ' - ' + opt.start"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.period_end" :multiple="false" placeholder="Last Period">
            <el-option
              v-for="opt in allCodes.periods"
              :key="opt.id"
              :label="opt.id + ' - ' + opt.start"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>

    <div v-if="reportOptions.dates==='datesPosted'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">Posting Date Start</el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">Posting Date End</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <DateField v-model="selectedCodes.time_posted_start" :key="reRender"/>
          <!-- <el-input v-model="selectedCodes.time_posted_start" placeholder="2001-01-01"/>-->
        </el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <DateField v-model="selectedCodes.time_posted_end" :key="reRender"/>
          <!-- <el-input v-model="selectedCodes.time_posted_end" placeholder="2099-12-31"/>-->
        </el-col>
      </el-row>
    </div>

    <div v-if="reportOptions.dates==='datesEffective'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">Effective Date Start <sup>**</sup></el-col>
        <el-col :span="3" />
        <el-col :span="4">Effective Date End <sup>**</sup></el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.effective_date_start" :key="reRender"/>
          <!-- <el-input v-model="selectedCodes.effective_date_start" placeholder="2001-01-01"/>-->
        </el-col>
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.effective_date_end" :key="reRender"/>
          <!-- <el-input v-model="selectedCodes.effective_date_end" placeholder="2099-12-31"/>-->
        </el-col>
      </el-row>
      <el-row v-if="reportOptions.dates==='datesEffective'" type="flex" align="middle" justify="start">
        <el-col :span="3"> </el-col>
        <el-col :span="21"><p><sup>**</sup> Posting Date is used if Effective Date is not Set</p></el-col>
      </el-row>
    </div>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Company
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedCodes.company_id" :multiple="false" placeholder="All">
          <el-option
            v-for="opt in allCodes.companies"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Production
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedCodes.production_id" :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.productions"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Series
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedCodes.series_id" :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.series"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Location
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.location_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.locations"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="(allCodes.currencies||[]).length > 1" type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Currency
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedCodes.currency_id" :multiple="true" placeholder="All">
          <el-option
            v-for="opt in currencies"
            :key="opt.id"
            :label="opt.code + ' - ' + parseFloat(opt.rate_vs_usd || 0).toFixed(4)"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Convert To
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportOptions.report_currency_id">
          <el-option
            v-for="opt in currencies"
            :key="opt.id"
            :label="opt.code + ' - ' + parseFloat(opt.rate_vs_usd || 0).toFixed(4)"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Output
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportOptions.format">
          <el-option
            v-for="opt in reportOutputFormats"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Condense Expenses
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="reportOptions.summarizeExpenses"></el-checkbox>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">

      </el-col>
      <el-radio-group :span="3" class="right" v-model="reportOptions.expenses" v-show="reportOptions.summarizeExpenses">
        <el-radio label="one_line">One Line</el-radio>
        <el-radio label="series">Series</el-radio>
        <el-radio label="location">Location</el-radio>
        <el-radio label="set">Set</el-radio>
      </el-radio-group>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Include POs
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="reportOptions.includePOs"></el-checkbox>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Hide $0 Accounts
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="reportOptions.hideZeroDollarAccounts"></el-checkbox>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow" v-if="showUnposted">
      <el-col :span="3" class="right">
        Include Unposted Items
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="reportOptions.includeunposted"></el-checkbox>
      </el-col>
    </el-row>
    <!--
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <p><sup>*</sup> Required</p>
      </el-col>
      <el-button plain @click="generateReport" :disabled="disableReportRun">
        Run report
      </el-button>
    </el-row>
    -->
    <el-row>
      <el-col v-if="showJson">
        <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
        <el-button plain @click="generateCustomReport" :disabled="disableReportRun">
          Run Customized Report
        </el-button>
      </el-col>
    </el-row>
    <el-dialog
    title="Report Options"
    size="tiny"
    :visible="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-row type="flex" align="middle" element-loading-text='Saving...'>
      <el-col>
        <el-row type="flex" align="middle">
          <el-form :model="form" ref="authForm" v-if="selectedReportOptions">
            <el-form-item style="margin-bottom: 6px;">
              Do you wish to update the Report Options saved under {{ selectedReportOptions.report_name }}
            </el-form-item>
          </el-form>
          <el-form :model="form" ref="authForm" v-if="empty_error">
            <el-form-item style="margin-bottom: 6px;">
              Please select a set of Report Options to load.
            </el-form-item>
          </el-form>
          <el-form :model="form" ref="authForm" v-if="delete_error">
            <el-form-item style="margin-bottom: 6px;">
              Please select a set of Report Options to delete.
            </el-form-item>
          </el-form>
          <el-form :model="form" ref="authForm" v-if="!selectedReportOptions && !empty_error && !delete_error">
            <el-form-item style="margin-bottom: 6px;">
              <el-input placeholder="Name" v-model="savereportoptions" ref="nameField">
              </el-input>
            </el-form-item>
          </el-form>
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="error" type="flex" align="middle" justify="center" style="padding-top: 12px;">
      <el-tag type="danger">{{ error }}</el-tag>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" class="auth-btn" v-if="!empty_error && !delete_error">
        Cancel
      </el-button>
      <el-button @click="saveOptions" class="auth-btn" type="primary">
        OK
      </el-button>
    </span>
  </el-dialog>
  <el-dialog
    title="Delete Report Options"
    size="tiny"
    :visible="visible_delete"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-row type="flex" align="middle" element-loading-text='Saving...'>
      <el-col>
        <el-row type="flex" align="middle">
          <el-form :model="form" ref="authForm">
            <el-form-item style="margin-bottom: 6px;">
              Do you want to delete report options?
            </el-form-item>
          </el-form>
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="error" type="flex" align="middle" justify="center" style="padding-top: 12px;">
      <el-tag type="danger">{{ error }}</el-tag>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible_delete = false" class="auth-btn">
        Cancel
      </el-button>
      <el-button @click="confirmDeleteOptions" class="auth-btn" type="primary">
        OK
      </el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { sortObjectByProperty } from '@/utils/helpers/ObjectSorting'
  import { reportMixins } from '@/Mixins/Reports'
  import DateField from '@/components/InputComponents/DateField.vue'
  import _ from 'lodash'
  import NewEntityForm from '@/components/NewEntityForm.vue'

  export default {
    name: 'trialBalance',
    components: { DateField, NewEntityForm },
    mixins: [ reportMixins ],
    props: {
    },
    data () {
      const { getJasperHost } = this.$store.getters
      return {
        report_group: 'Trial_Balance',
        savereportoptions: '',
        isBusy: false,
        visible: false,
        empty_error: false,
        delete_error: false,
        newAddedReport: {},
        selectedReportOptions: null,
        savedReportOptions: [],
        selectedOption: null,
        visible_delete: false,
        reportOptions: undefined,
        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        reRender: 0,
        allCodes: [],    // Show codes, e.g. accounts, series, locations, sets, etc.
        selectedCodes: undefined,
        jasperSettings: {
          reportServer: `${getJasperHost}rest_v2/reports/Revolution/Phoenix/`,
          reportName: 'trial_balance_detail'
        },
        vendors: undefined,
        transactionTypes: {     // Types of transactions and whether we need them or not
          'aps': { name: 'AP', include: true },
          'jes': { name: 'JE', include: true },
          'pcs': { name: 'PC', include: true },
          'cks': { name: 'CK', include: true },
          'pos': { name: 'PO', include: false },
          'efts': { name: 'EFT', include: true },
          'wts': { name: 'WIRE', include: true },
          'mcs': { name: 'MC', include: true }
        },
        unserializedData: {      // Raw data from API
          aps: {
            headers: {},
            lines: {}
          },
          jes: {
            headers: {},
            lines: {}
          },
          pcs: {
            headers: {},
            lines: {}
          },
          cks: {
            headers: {},
            lines: {}
          },
          pos: {
            headers: {},
            lines: {}
          }
        },
        sortedAccounts: [],     // Sorted data by accounts, transaction ID.  Needed for 90% of reports
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        collapseExpenses: false,
        loading: false,
        form: {save_options: { label: '', value: '' }}
      }
    },
    computed: {
      username () { return this.$store.getters.getUser.username },
      includedTypes () { return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name) },
      currencies () {
        if (typeof this.allCodes.currencies !== 'undefined' && this.allCodes.currencies.length > 0) {
          return sortObjectByProperty(this.allCodes.currencies, 'id')
        } else {
          return []
        }
      },
      dateStart () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start) || {}).start || '0000/00/00'

          case 'datesEffective':
            return this.selectedCodes.effective_date_start || '0000/00/00'

          case 'datesPosted':
            return this.selectedCodes.time_posted_start || '0000/00/00'

          default:
            return 'ALL'
        }
      },
      dateEnd () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end) || {}).end || '9999/99/99'

          case 'datesEffective':
            return this.selectedCodes.effective_date_end || '9999/99/99'

          case 'datesPosted':
            return this.selectedCodes.time_posted_end || '9999/99/99'

          default:
            return 'ALL'
        }
      },
      showUnposted () {
        return this.$store.getters.getUiSettings['TRIAL_BALANCE_REPORT_DEFAULT_SETTINGS'] && JSON.parse(this.$store.getters.getUiSettings['TRIAL_BALANCE_REPORT_DEFAULT_SETTINGS']).showUnposted ? JSON.parse(this.$store.getters.getUiSettings['TRIAL_BALANCE_REPORT_DEFAULT_SETTINGS']).showUnposted : false
      }
    },
    methods: {
      resetComponent () {
        this.reportJson = this.vendors = this.sortedAccounts = undefined
        this.clearStore()
        this.resetFilters()
      },
      clearStore () {
        // TODO
      },
      updateReportType (type) {
        this.jasperSettings.reportName = 'trial_balance_' + type
      },
      updateReportDates (type) {
        this.selectedCodes.period_start = this.selectedCodes.period_end = this.selectedCodes.time_posted_start = this.selectedCodes.time_posted_end = this.selectedCodes.effective_date_start = this.selectedCodes.effective_date_end = undefined
      },
      buildTrialBalanceSummary (sortedAccounts) {
        return new Promise((resolve, reject) => {
          let json = {
            report: {
              report_title: 'Trial Balance Summary',
              report_subtitle: '',
              report_name: 'trial_balance_summary',
              printed_by: this.username,
              date_run: this.today(),
              company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id).name) : this.allCodes.companies[0].name,
              project:
                this.selectedCodes.production_id && this.selectedCodes.production_id.length
                ? this.allCodes.productions.filter((prod) => this.selectedCodes.production_id.includes(prod.id)).map((prod) => prod.name).join(', ')
                : this.allCodes.productions[0].name,
              period: this.dateStart + ' - ' + this.dateEnd,
              currency: (this.reportOptions.report_currency_id) ? (this.allCodes.currencies.find(({id}) => id === this.reportOptions.report_currency_id).code) : this.currencies[0].code,
              date_start: this.dateStart,
              date_end: this.dateEnd,
              total_beginning: 0,
              total_current: 0,
              total_ending: 0,
              data: []
            }
          }

          // this is the data portion of the report
          let tb = [
            { assets: { group: 'ASSETS', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
            { liabilities: { group: 'LIABILITIES', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
            { income: { group: 'INCOME', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
            { expenses: { group: 'EXPENSES', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } }
            // { 'expense_atl': { group: 'ABOVE THE LINE', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
            // { 'expense_btl': { group: 'BELOW THE LINE', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
            // { 'expense_post': { group: 'POST', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
            // { 'expense_other': { group: 'OTHER', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } }
          ]
          // console.log(tb)

          // group accounts by account type
          let groups = {
            assets: (this.allCodes.accounts.filter(({type}) => { return (type === 'ASSET') })),
            liabilities: (this.allCodes.accounts.filter(({type}) => { return (type === 'LIABILITY') })),
            income: (this.allCodes.accounts.filter(({type}) => { return (type === 'INCOME') })),
            // capital: (this.allCodes.accounts.filter(({type}) => { return (type === 'CAPITAL') })),
            expenses: (this.allCodes.accounts.filter(({type}) => { return (type.match('EXPENSE')) }))
            // 'expense_atl': (this.allCodes.accounts.filter(( {type} ) => { return (type === 'EXPENSE_ATL') })),
            // 'expense_btl': (this.allCodes.accounts.filter(( {type} ) => { return (type === 'EXPENSE_BTL') })),
            // 'expense_post': (this.allCodes.accounts.filter(( {type} ) => { return (type === 'EXPENSE_POST') })),
            // 'expense_other': (this.allCodes.accounts.filter(( {type} ) => { return (type === 'EXPENSE') }))
          }

           // 06-30-2022
          // Extracting / grouping data from sortedAccounts based in selected condense report option
          if (this.reportOptions.summarizeExpenses && ['series', 'set', 'location'].indexOf(this.reportOptions.expenses) > -1) {
            Object.assign(sortedAccounts.current, _.groupBy([].concat.apply([], groups['expenses'].map(e => {
              e.data = sortedAccounts.current[e.code]
              e.key = this.reportOptions.expenses
              return e
            }).filter(e => !!e.data).map(e => e.data)), this.reportOptions.expenses))

            Object.assign(sortedAccounts.previous, _.groupBy([].concat.apply([], groups['expenses'].map(e => {
              e.data = sortedAccounts.previous[e.code]
              e.key = this.reportOptions.expenses
              return e
            }).filter(e => !!e.data).map(e => e.data)), this.reportOptions.expenses))

            Object.assign(sortedAccounts.future, _.groupBy([].concat.apply([], groups['expenses'].map(e => {
              e.data = sortedAccounts.future[e.code]
              e.key = this.reportOptions.expenses
              return e
            }).filter(e => !!e.data).map(e => e.data)), this.reportOptions.expenses))

            let _eOptionData = new RegExp('s$').test(this.reportOptions.expenses) ? this.allCodes[this.reportOptions.expenses] : this.allCodes[`${this.reportOptions.expenses}s`]

            if (this.selectedCodes[`${this.reportOptions.expenses}_id`].length) {
              _eOptionData = _eOptionData.filter(e => this.selectedCodes[`${this.reportOptions.expenses}_id`].indexOf(e.code))
            }

            groups.expenses = _eOptionData.map((e) => {
              e.key = this.reportOptions.expenses
              return e
            })

            // Assign Default Header and group
            tb[3].expenses.account_headers.push({
              key: this.reportOptions.expenses,
              parentName: this.reportOptions.expenses.toUpperCase(),
              parentCode: 'CODE',
              parentId: 'DESCRIPTION',
              account_header: 'CODE',
              account_header_name: this.reportOptions.expenses.toUpperCase(),
              account_header_beginning: '0.00',
              account_header_current: '0.00',
              account_header_current_debits: '0.00',
              account_header_current_credits: '0.00',
              account_header_future: '0.00',
              account_header_ending: '0.00',
              accounts: []
            })
          }

          Object.keys(groups).forEach((group, index) => {
            if (Array.isArray(groups[group])) {
              groups[group].forEach((data, ind) => {
                let account = {}
                account.account_header_name = data.name
                account.account_header = data.code
                account.account_id = data.id
                account.account_parent = data.parent
                // account.account_header_beginning = 0.00

                // Now look through actual data and put into the proper group
                if (sortedAccounts.current[data.code] || sortedAccounts.previous[data.code] || sortedAccounts.future[data.code]) {
                  // account.accounts = sortedAccounts.current[data.code] || sortedAccounts.previous[data.code]
                  account.account_header_beginning = (sortedAccounts.previous[data.code]) ? this.sumRecursive(sortedAccounts.previous[data.code], 'amount') : '0.00'
                  account.account_header_current = (sortedAccounts.current[data.code]) ? this.sumRecursive(sortedAccounts.current[data.code], 'amount') : '0.00'
                  account.account_header_future = (sortedAccounts.future[data.code]) ? this.sumRecursive(sortedAccounts.future[data.code], 'amount') : '0.00'
                  account.account_header_ending = (parseFloat(account.account_header_beginning) + parseFloat(account.account_header_current)).toFixed(2)

                  // Hide zero dollar accounts
                  if (this.reportOptions.hideZeroDollarAccounts && parseFloat(account.account_header_beginning) === 0 && parseFloat(account.account_header_current) === 0 && parseFloat(account.account_header_ending) === 0) {
                    // Do nothing
                  } else {
                    // Add the account
                    tb.find((data, ind) => { return (Object.keys(data)[0] === group) })[group].account_headers.push(account)
                  }
                }
              })
            }

            let tbal = tb.find((data, ind) => { return (Object.keys(data)[0] === group) })[group]
            let groupSumPrevious = this.sumRecursive(tbal.account_headers, 'account_header_beginning')
            let groupSumCurrent = this.sumRecursive(tbal.account_headers, 'account_header_current')
            let groupSumEnding = this.sumRecursive(tbal.account_headers, 'account_header_ending')
            tbal.group_beginning = groupSumPrevious
            tbal.group_current = groupSumCurrent
            tbal.group_ending = groupSumEnding
          })

          // tb.map((val) => json.report.data.push(Object.values(val)[0]))
          tb.map((groups) => {
            const groupName = Object.keys(groups)[0] // First element of object has the data
            const group = groups[groupName] || {}

            // Don't show detail for expenses
            if (groupName === 'expenses' && this.reportOptions.summarizeExpenses) {
              group.account_headers = [
                {
                  account_header: '---',
                  account_header_beginning: group.group_beginning,
                  account_header_current: group.group_current,
                  account_header_ending: group.group_ending,
                  account_header_name: 'ALL EXPENSES'
                }
              ]
              json.report.data.push(group)
            } else if (group.account_headers && group.account_headers.length > 0) {
              json.report.data.push(group)
            }
          })

          let totalSumPrevious = this.sumRecursive(json.report.data, 'group_beginning')
          let totalSumCurrent = this.sumRecursive(json.report.data, 'group_current')
          let totalSumEnding = this.sumRecursive(json.report.data, 'group_ending')
          json.report.total_beginning = totalSumPrevious
          json.report.total_current = totalSumCurrent
          json.report.total_ending = totalSumEnding

          // Add purchase order lines if needed
          if (this.reportOptions.includePOs) {
            let purchaseOrders = { group: 'PURCHASE ORDERS', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] }
            const poAccounts = (this.allCodes.accounts.filter(({type}) => { return (type.match('EXPENSE')) }))
            poAccounts.forEach((data, ind) => {
              let account = {}
              account.account_name = data.name
              account.account_number = data.code
              account.account_id = data.id

              // Now look through actual data and put into the proper group
              if (sortedAccounts.purchaseOrders.current[data.code] || sortedAccounts.purchaseOrders.previous[data.code] || sortedAccounts.purchaseOrders.future[data.code]) {
                account.account_beginning = (sortedAccounts.purchaseOrders.previous[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.previous[data.code], 'amount') : '0.00'
                account.account_current = (sortedAccounts.purchaseOrders.current[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.current[data.code], 'amount') : '0.00'
                // account.account_current_debits = (sortedAccounts.purchaseOrders.current[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.current[data.code], 'amount', 'debits', group) : '0.00'
                // account.account_current_credits = (sortedAccounts.purchaseOrders.current[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.current[data.code], 'amount', 'credits', group) : '0.00'
                account.account_current_debits = 0
                account.account_current_credits = 0
                account.account_future = (sortedAccounts.purchaseOrders.future[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.future[data.code], 'amount') : '0.00'
                account.account_ending = (parseFloat(account.account_beginning) + parseFloat(account.account_current)).toFixed(2)
              } else {
                account.account_beginning = 0
                account.account_current = 0
                account.account_current_debits = 0
                account.account_current_credits = 0
                account.account_future = 0
                account.account_ending = 0
              }

              // Don't process if no data
              if (sortedAccounts.purchaseOrders.current[data.code] || sortedAccounts.purchaseOrders.previous[data.code]) {
                let tbHeaders = purchaseOrders.account_headers
                let tbGroup = tbHeaders.find((acct) => acct.account_id === data.parent) || undefined

                // Add Headers
                let parentName = (this.allCodes.accounts.find((acct) => acct.id === data.parent) || {}).name || 'Not Set'
                let parentCode = (this.allCodes.accounts.find((acct) => acct.id === data.parent) || {}).code || 'Not Set'
                let parentId = data.parent || 'Not Set'

                if (!tbGroup) {
                  let parent = {}
                  parent.account_header_name = parentName + ' (PO)'
                  parent.account_header = parentCode
                  parent.account_id = parentId
                  parent.account_header_beginning = account.account_beginning || '0.00'
                  parent.account_header_current = account.account_current || '0.00'
                  // parent.account_header_current_debits = account.account_current_debits || '0.00'
                  // parent.account_header_current_credits = account.account_current_credits || '0.00'
                  parent.account_header_current_debits = '0.00'
                  parent.account_header_current_credits = '0.00'
                  parent.account_header_future = account.account_future || '0.00'
                  parent.account_header_ending = account.account_ending || '0.00'
                  parent.accounts = []

                  // Hide zero dollar accounts
                  if (this.reportOptions.hideZeroDollarAccounts && parseFloat(account.account_beginning) === 0 && parseFloat(account.account_current) === 0 && parseFloat(account.account_ending) === 0) {
                    // Do nothing
                  } else {
                    // Add the account
                    parent.accounts.push(account)
                  }

                  tbHeaders.push(parent)
                } else {
                  tbGroup.account_header_beginning = parseFloat(tbGroup.account_header_beginning) + parseFloat(account.account_beginning)
                  tbGroup.account_header_current = parseFloat(tbGroup.account_header_current) + parseFloat(account.account_current)
                  // tbGroup.account_header_current_debits = parseFloat(tbGroup.account_header_current_debits) + parseFloat(account.account_current_debits)
                  // tbGroup.account_header_current_credits = parseFloat(tbGroup.account_header_current_credits) + parseFloat(account.account_current_credits)
                  tbGroup.account_header_future = parseFloat(tbGroup.account_header_future) + parseFloat(account.account_future)
                  tbGroup.account_header_ending = parseFloat(tbGroup.account_header_ending) + parseFloat(account.account_ending)

                  // Hide zero dollar accounts
                  if (this.reportOptions.hideZeroDollarAccounts && parseFloat(account.account_beginning) === 0 && parseFloat(account.account_current) === 0 && parseFloat(account.account_ending) === 0) {
                    // Do nothing
                  } else {
                    // Add the account
                    tbGroup.accounts.push(account)
                  }
                }
              }
            })

            let groupSumPrevious = this.sumRecursive(purchaseOrders.account_headers, 'account_header_beginning')
            let groupSumCurrent = this.sumRecursive(purchaseOrders.account_headers, 'account_header_current')
            let groupSumCurrentDebits = this.sumRecursive(purchaseOrders.account_headers, 'account_header_current_debits')
            let groupSumCurrentCredits = this.sumRecursive(purchaseOrders.account_headers, 'account_header_current_credits')
            let groupSumEnding = this.sumRecursive(purchaseOrders.account_headers, 'account_header_ending')
            purchaseOrders.group_beginning = groupSumPrevious
            purchaseOrders.group_current = groupSumCurrent
            purchaseOrders.group_current_debits = groupSumCurrentDebits
            purchaseOrders.group_current_credits = groupSumCurrentCredits
            purchaseOrders.group_ending = groupSumEnding

            // Need to offset our new PO "expenses" with a liability
            let committedLiability = {
              account_header: '-',
              account_header_beginning: (parseFloat(groupSumPrevious) * -1).toFixed(2),
              account_header_current: (parseFloat(groupSumCurrent) * -1).toFixed(2),
              account_header_current_credits: (parseFloat(groupSumCurrentDebits) * -1).toFixed(2),
              account_header_current_debits: (parseFloat(groupSumCurrentCredits) * -1).toFixed(2),
              account_header_ending: (parseFloat(groupSumEnding) * -1).toFixed(2),
              account_header_future: '0.00',
              account_header_name: 'PURCHASE ORDER COMMITMENTS',
              account_id: '',
              accounts: []
            }

            let liabilityGroup = tb.find((data) => { return (Object.keys(data)[0] === 'liabilities') }).liabilities
            liabilityGroup.account_headers.push(committedLiability)
            liabilityGroup.group_beginning = this.sumRecursive(liabilityGroup.account_headers, 'account_header_beginning')
            liabilityGroup.group_current = this.sumRecursive(liabilityGroup.account_headers, 'account_header_current')
            liabilityGroup.group_current_debits = this.sumRecursive(liabilityGroup.account_headers, 'account_header_current_debits')
            liabilityGroup.group_current_credits = this.sumRecursive(liabilityGroup.account_headers, 'account_header_current_credits')
            liabilityGroup.group_ending = this.sumRecursive(liabilityGroup.account_headers, 'account_header_ending')

            // In the rare chance that there are no liabilities on the TB
            if (!json.report.data.find((data) => { return (data.group === 'LIABILITIES') })) {
              json.report.data.splice(1, 0, liabilityGroup)
            }

            // Don't show detail for expenses
            if (this.reportOptions.summarizeExpenses) {
              purchaseOrders.account_headers = []
              json.report.data.push(purchaseOrders)
            } else if (purchaseOrders.account_headers && purchaseOrders.account_headers.length > 0) {
              json.report.data.push(purchaseOrders)
            }

            // Only needed if users want the liability to be separate from other liabilities
            /*
            let committedLiabilities = Object.assign({}, purchaseOrders)
            committedLiabilities.group = 'Liability from Commitments'
            committedLiabilities.group_beginning = (parseFloat(groupSumPrevious) * -1).toFixed(2)
            committedLiabilities.group_current = (parseFloat(groupSumCurrent) * -1).toFixed(2)
            committedLiabilities.group_current_debits = (parseFloat(groupSumCurrentDebits) * -1).toFixed(2)
            committedLiabilities.group_current_credits = (parseFloat(groupSumCurrentCredits) * -1).toFixed(2)
            committedLiabilities.group_ending = (parseFloat(groupSumEnding) * -1).toFixed(2)
            committedLiabilities.account_headers = []
            // tb.push({ purchaseOrders })
            // json.report.data.push(committedLiabilities)
            */
          }

          resolve(json)
        })
      },
      buildTrialBalance (sortedAccounts) {
        return new Promise((resolve, reject) => {
          let json = {
            report: {
              report_title: 'Trial Balance Detail',
              report_subtitle: '',
              report_name: 'trial_balance_detail',
              printed_by: this.username,
              date_run: this.today(),
              company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id).name) : this.allCodes.companies[0].name,
              project:
                this.selectedCodes.production_id && this.selectedCodes.production_id.length
                ? this.allCodes.productions.filter((prod) => this.selectedCodes.production_id.includes(prod.id)).map((prod) => prod.name).join(', ')
                : this.allCodes.productions[0].name,
              period: this.dateStart + ' - ' + this.dateEnd,
              currency: (this.reportOptions.report_currency_id) ? (this.allCodes.currencies.find(({id}) => id === this.reportOptions.report_currency_id).code) : this.currencies[0].code,
              date_start: this.dateStart,
              date_end: this.dateEnd,
              total_beginning: 0,
              total_current: 0,
              total_current_debits: 0,
              total_current_credits: 0,
              total_ending: 0,
              data: []
            }
          }

          // this is the data portion of the report
          let tb = [
            { assets: { group: 'ASSETS', group_beginning: 0, group_current: 0, group_current_debits: 0, group_current_credits: 0, group_ending: 0, account_headers: [] } },
            { liabilities: { group: 'LIABILITIES', group_beginning: 0, group_current: 0, group_current_debits: 0, group_current_credits: 0, group_ending: 0, account_headers: [] } },
            { income: { group: 'INCOME', group_beginning: 0, group_current: 0, group_current_debits: 0, group_current_credits: 0, group_ending: 0, account_headers: [] } },
            { expenses: { group: 'EXPENSES', group_beginning: 0, group_current: 0, group_current_debits: 0, group_current_credits: 0, group_ending: 0, account_headers: [] } }
          ]

          // group accounts by account type
          let groups = {
            assets: (this.allCodes.accounts.filter(({type}) => { return (type.match('ASSET')) })),
            liabilities: (this.allCodes.accounts.filter(({type}) => { return (type === 'LIABILITY') })),
            income: (this.allCodes.accounts.filter(({type}) => { return (type === 'INCOME' || type === 'CAPITAL') })),
            expenses: (this.allCodes.accounts.filter(({type}) => { return (type.match('EXPENSE') || type === 'COGS') }))
          }

          // 06-30-2022
          // Extracting / grouping data from sortedAccounts based in selected condense report option
          if (this.reportOptions.summarizeExpenses && ['series', 'set', 'location'].indexOf(this.reportOptions.expenses) > -1) {
            Object.assign(sortedAccounts.current, _.groupBy([].concat.apply([], groups['expenses'].map(e => {
              e.data = sortedAccounts.current[e.code]
              e.key = this.reportOptions.expenses
              return e
            }).filter(e => !!e.data).map(e => e.data)), this.reportOptions.expenses))

            Object.assign(sortedAccounts.previous, _.groupBy([].concat.apply([], groups['expenses'].map(e => {
              e.data = sortedAccounts.previous[e.code]
              e.key = this.reportOptions.expenses
              return e
            }).filter(e => !!e.data).map(e => e.data)), this.reportOptions.expenses))

            Object.assign(sortedAccounts.future, _.groupBy([].concat.apply([], groups['expenses'].map(e => {
              e.data = sortedAccounts.future[e.code]
              e.key = this.reportOptions.expenses
              return e
            }).filter(e => !!e.data).map(e => e.data)), this.reportOptions.expenses))

            let _eOptionData = new RegExp('s$').test(this.reportOptions.expenses) ? this.allCodes[this.reportOptions.expenses] : this.allCodes[`${this.reportOptions.expenses}s`]

            if (this.selectedCodes[`${this.reportOptions.expenses}_id`].length) {
              _eOptionData = _eOptionData.filter(e => this.selectedCodes[`${this.reportOptions.expenses}_id`].indexOf(e.code))
            }

            groups.expenses = _eOptionData.map((e) => {
              e.key = this.reportOptions.expenses
              return e
            })

            // Assign Default Header and group
            tb[3].expenses.account_headers.push({
              key: this.reportOptions.expenses,
              parentName: this.reportOptions.expenses.toUpperCase(),
              parentCode: 'CODE',
              parentId: 'DESCRIPTION',
              account_header: 'CODE',
              account_header_name: this.reportOptions.expenses.toUpperCase(),
              account_header_beginning: '0.00',
              account_header_current: '0.00',
              account_header_current_debits: '0.00',
              account_header_current_credits: '0.00',
              account_header_future: '0.00',
              account_header_ending: '0.00',
              accounts: []
            })
          }

          // Iterate through groups (assets, liabilies, etc) to put data into account form.
          Object.keys(groups).forEach((group, index) => {
            if (Array.isArray(groups[group])) {
              groups[group].forEach((data, ind) => {
                // Gather each account data
                let account = {}
                account.account_name = data.name
                account.account_number = data.code
                account.account_id = data.id

                // Now look through actual data and put into the proper group
                if (sortedAccounts.current[data.code] || sortedAccounts.previous[data.code] || sortedAccounts.future[data.code]) {
                  account.account_beginning = (sortedAccounts.previous[data.code]) ? this.sumRecursive(sortedAccounts.previous[data.code], 'amount') : '0.00'
                  account.account_current = (sortedAccounts.current[data.code]) ? this.sumRecursive(sortedAccounts.current[data.code], 'amount') : '0.00'
                  account.account_current_debits = (sortedAccounts.current[data.code]) ? this.sumRecursive(sortedAccounts.current[data.code], 'amount', 'debits', group) : '0.00'
                  account.account_current_credits = (sortedAccounts.current[data.code]) ? this.sumRecursive(sortedAccounts.current[data.code], 'amount', 'credits', group) : '0.00'
                  account.account_future = (sortedAccounts.future[data.code]) ? this.sumRecursive(sortedAccounts.future[data.code], 'amount') : '0.00'
                  account.account_ending = (parseFloat(account.account_beginning) + parseFloat(account.account_current)).toFixed(2)
                } else {
                  account.account_beginning = 0
                  account.account_current = 0
                  account.account_current_debits = 0
                  account.account_current_credits = 0
                  account.account_future = 0
                  account.account_ending = 0
                }

                // Don't process if no data
                if (sortedAccounts.current[data.code] || sortedAccounts.previous[data.code]) {
                  let tbHeaders = tb[index][group].account_headers
                  let tbGroup = tbHeaders.find((acct) => acct.account_id === data.parent) || undefined

                  // Add Headers
                  let parentName = (this.allCodes.accounts.find((acct) => acct.id === data.parent) || {}).name || 'Not Set'
                  let parentCode = (this.allCodes.accounts.find((acct) => acct.id === data.parent) || {}).code || 'Not Set'
                  let parentId = data.parent || 'Not Set'

                  // Add headers based on filters for expenses
                  // 06-30-2022
                  if (group === 'expenses' && this.reportOptions.summarizeExpenses && ['series', 'set', 'location'].indexOf(this.reportOptions.expenses) > -1) {
                    // parentName = groups[group][ind].name;
                    // parentCode = groups[group][ind].code;
                    // parentId = groups[group][ind].id;

                    tbGroup = tbHeaders.find((acct) => acct.key === data.key) || undefined
                  }

                  if (!tbGroup) {
                    let parent = {}
                    parent.account_header_name = parentName
                    parent.account_header = parentCode
                    parent.account_id = parentId
                    parent.account_header_beginning = account.account_beginning || '0.00'
                    parent.account_header_current = account.account_current || '0.00'
                    parent.account_header_current_debits = account.account_current_debits || '0.00'
                    parent.account_header_current_credits = account.account_current_credits || '0.00'
                    parent.account_header_future = account.account_future || '0.00'
                    parent.account_header_ending = account.account_ending || '0.00'
                    parent.accounts = []

                    // Hide zero dollar accounts
                    if (this.reportOptions.hideZeroDollarAccounts && parseFloat(account.account_beginning) === 0 && parseFloat(account.account_current) === 0 && parseFloat(account.account_ending) === 0) {
                      // Do nothing
                    } else {
                      // Add the account
                      parent.accounts.push(account)
                    }

                    tbHeaders.push(parent)
                  } else {
                    tbGroup.account_header_beginning = parseFloat(tbGroup.account_header_beginning) + parseFloat(account.account_beginning)
                    tbGroup.account_header_current = parseFloat(tbGroup.account_header_current) + parseFloat(account.account_current)
                    tbGroup.account_header_current_debits = parseFloat(tbGroup.account_header_current_debits) + parseFloat(account.account_current_debits)
                    tbGroup.account_header_current_credits = parseFloat(tbGroup.account_header_current_credits) + parseFloat(account.account_current_credits)
                    tbGroup.account_header_future = parseFloat(tbGroup.account_header_future) + parseFloat(account.account_future)
                    tbGroup.account_header_ending = parseFloat(tbGroup.account_header_ending) + parseFloat(account.account_ending)

                    // Hide zero dollar accounts
                    if (this.reportOptions.hideZeroDollarAccounts && parseFloat(account.account_beginning) === 0 && parseFloat(account.account_current) === 0 && parseFloat(account.account_ending) === 0) {
                      // Do nothing
                    } else {
                      // Add the account
                      tbGroup.accounts.push(account)
                    }
                  }
                }
              })
            }

            let tbal = tb.find((data, ind) => { return (Object.keys(data)[0] === group) })[group]
            let groupSumPrevious = this.sumRecursive(tbal.account_headers, 'account_header_beginning')
            let groupSumCurrent = this.sumRecursive(tbal.account_headers, 'account_header_current')
            let groupSumCurrentDebits = this.sumRecursive(tbal.account_headers, 'account_header_current_debits')
            let groupSumCurrentCredits = this.sumRecursive(tbal.account_headers, 'account_header_current_credits')
            let groupSumEnding = this.sumRecursive(tbal.account_headers, 'account_header_ending')
            tbal.group_beginning = groupSumPrevious
            tbal.group_current = groupSumCurrent
            tbal.group_current_debits = groupSumCurrentDebits
            tbal.group_current_credits = groupSumCurrentCredits
            tbal.group_ending = groupSumEnding
          })

          tb.map((groups) => {
            const groupName = Object.keys(groups)[0] // First element of object has the data
            const group = groups[groupName] || {}

            // Custom Condition for expenses
            if (groupName === 'expenses') {
              // Don't show detail for expenses if Condense Expenses is not selected
              // Don't show detail for expenses if Condense Expenses is selected and selected expense is one_line
              // 06-30-2022
              if ((this.reportOptions.expenses === 'one_line' && this.reportOptions.summarizeExpenses)) {
                group.account_headers = []
              }
              json.report.data.push(group)
            } else if (group.account_headers && group.account_headers.length > 0) {
              json.report.data.push(group)
            }
          })

          let totalSumPrevious = this.sumRecursive(json.report.data, 'group_beginning')
          let totalSumCurrent = this.sumRecursive(json.report.data, 'group_current')
          let totalSumCurrentDebits = this.sumRecursive(json.report.data, 'group_current_debits')
          let totalSumCurrentCredits = this.sumRecursive(json.report.data, 'group_current_credits')
          let totalSumEnding = this.sumRecursive(json.report.data, 'group_ending')
          json.report.total_beginning = totalSumPrevious
          json.report.total_current = totalSumCurrent
          json.report.total_current_debits = totalSumCurrentDebits
          json.report.total_current_credits = totalSumCurrentCredits
          json.report.total_ending = totalSumEnding

          // Add purchase order lines if needed
          if (this.reportOptions.includePOs) {
            let purchaseOrders = { group: 'PURCHASE ORDERS', group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] }
            const poAccounts = (this.allCodes.accounts.filter(({type}) => { return (type.match('EXPENSE')) }))
            poAccounts.forEach((data, ind) => {
              let account = {}
              account.account_name = data.name
              account.account_number = data.code
              account.account_id = data.id

              // Now look through actual data and put into the proper group
              if (sortedAccounts.purchaseOrders.current[data.code] || sortedAccounts.purchaseOrders.previous[data.code] || sortedAccounts.purchaseOrders.future[data.code]) {
                account.account_beginning = (sortedAccounts.purchaseOrders.previous[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.previous[data.code], 'amount') : '0.00'
                account.account_current = (sortedAccounts.purchaseOrders.current[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.current[data.code], 'amount') : '0.00'
                // account.account_current_debits = (sortedAccounts.purchaseOrders.current[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.current[data.code], 'amount', 'debits', group) : '0.00'
                // account.account_current_credits = (sortedAccounts.purchaseOrders.current[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.current[data.code], 'amount', 'credits', group) : '0.00'
                account.account_current_debits = 0
                account.account_current_credits = 0
                account.account_future = (sortedAccounts.purchaseOrders.future[data.code]) ? this.sumRecursive(sortedAccounts.purchaseOrders.future[data.code], 'amount') : '0.00'
                account.account_ending = (parseFloat(account.account_beginning) + parseFloat(account.account_current)).toFixed(2)
              } else {
                account.account_beginning = 0
                account.account_current = 0
                account.account_current_debits = 0
                account.account_current_credits = 0
                account.account_future = 0
                account.account_ending = 0
              }

              // Don't process if no data
              if (sortedAccounts.purchaseOrders.current[data.code] || sortedAccounts.purchaseOrders.previous[data.code]) {
                let tbHeaders = purchaseOrders.account_headers
                let tbGroup = tbHeaders.find((acct) => acct.account_id === data.parent) || undefined

                // Add Headers
                let parentName = (this.allCodes.accounts.find((acct) => acct.id === data.parent) || {}).name || 'Not Set'
                let parentCode = (this.allCodes.accounts.find((acct) => acct.id === data.parent) || {}).code || 'Not Set'
                let parentId = data.parent || 'Not Set'

                if (!tbGroup) {
                  let parent = {}
                  parent.account_header_name = parentName + ' (PO)'
                  parent.account_header = parentCode
                  parent.account_id = parentId
                  parent.account_header_beginning = account.account_beginning || '0.00'
                  parent.account_header_current = account.account_current || '0.00'
                  // parent.account_header_current_debits = account.account_current_debits || '0.00'
                  // parent.account_header_current_credits = account.account_current_credits || '0.00'
                  parent.account_header_current_debits = '0.00'
                  parent.account_header_current_credits = '0.00'
                  parent.account_header_future = account.account_future || '0.00'
                  parent.account_header_ending = account.account_ending || '0.00'
                  parent.accounts = []

                  // Hide zero dollar accounts
                  if (this.reportOptions.hideZeroDollarAccounts && parseFloat(account.account_beginning) === 0 && parseFloat(account.account_current) === 0 && parseFloat(account.account_ending) === 0) {
                    // Do nothing
                  } else {
                    // Add the account
                    parent.accounts.push(account)
                  }

                  tbHeaders.push(parent)
                } else {
                  tbGroup.account_header_beginning = parseFloat(tbGroup.account_header_beginning) + parseFloat(account.account_beginning)
                  tbGroup.account_header_current = parseFloat(tbGroup.account_header_current) + parseFloat(account.account_current)
                  // tbGroup.account_header_current_debits = parseFloat(tbGroup.account_header_current_debits) + parseFloat(account.account_current_debits)
                  // tbGroup.account_header_current_credits = parseFloat(tbGroup.account_header_current_credits) + parseFloat(account.account_current_credits)
                  tbGroup.account_header_future = parseFloat(tbGroup.account_header_future) + parseFloat(account.account_future)
                  tbGroup.account_header_ending = parseFloat(tbGroup.account_header_ending) + parseFloat(account.account_ending)

                  // Hide zero dollar accounts
                  if (this.reportOptions.hideZeroDollarAccounts && parseFloat(account.account_beginning) === 0 && parseFloat(account.account_current) === 0 && parseFloat(account.account_ending) === 0) {
                    // Do nothing
                  } else {
                    // Add the account
                    tbGroup.accounts.push(account)
                  }
                }
              }
            })

            let groupSumPrevious = this.sumRecursive(purchaseOrders.account_headers, 'account_header_beginning')
            let groupSumCurrent = this.sumRecursive(purchaseOrders.account_headers, 'account_header_current')
            let groupSumCurrentDebits = this.sumRecursive(purchaseOrders.account_headers, 'account_header_current_debits')
            let groupSumCurrentCredits = this.sumRecursive(purchaseOrders.account_headers, 'account_header_current_credits')
            let groupSumEnding = this.sumRecursive(purchaseOrders.account_headers, 'account_header_ending')
            purchaseOrders.group_beginning = groupSumPrevious
            purchaseOrders.group_current = groupSumCurrent
            purchaseOrders.group_current_debits = groupSumCurrentDebits
            purchaseOrders.group_current_credits = groupSumCurrentCredits
            purchaseOrders.group_ending = groupSumEnding

            // Need to offset our new PO "expenses" with a liability
            let committedLiability = {
              account_header: '-',
              account_header_beginning: (parseFloat(groupSumPrevious) * -1).toFixed(2),
              account_header_current: (parseFloat(groupSumCurrent) * -1).toFixed(2),
              account_header_current_credits: (parseFloat(groupSumCurrentDebits) * -1).toFixed(2),
              account_header_current_debits: (parseFloat(groupSumCurrentCredits) * -1).toFixed(2),
              account_header_ending: (parseFloat(groupSumEnding) * -1).toFixed(2),
              account_header_future: '0.00',
              account_header_name: 'PURCHASE ORDER COMMITMENTS',
              account_id: '',
              accounts: []
            }

            let liabilityGroup = tb.find((data) => { return (Object.keys(data)[0] === 'liabilities') }).liabilities
            liabilityGroup.account_headers.push(committedLiability)
            liabilityGroup.group_beginning = this.sumRecursive(liabilityGroup.account_headers, 'account_header_beginning')
            liabilityGroup.group_current = this.sumRecursive(liabilityGroup.account_headers, 'account_header_current')
            liabilityGroup.group_current_debits = this.sumRecursive(liabilityGroup.account_headers, 'account_header_current_debits')
            liabilityGroup.group_current_credits = this.sumRecursive(liabilityGroup.account_headers, 'account_header_current_credits')
            liabilityGroup.group_ending = this.sumRecursive(liabilityGroup.account_headers, 'account_header_ending')

            // In the rare chance that there are no liabilities on the TB
            if (!json.report.data.find((data) => { return (data.group === 'LIABILITIES') })) {
              json.report.data.splice(1, 0, liabilityGroup)
            }

            // Don't show detail for expenses
            if (this.reportOptions.summarizeExpenses) {
              purchaseOrders.account_headers = []
              json.report.data.push(purchaseOrders)
            } else if (purchaseOrders.account_headers && purchaseOrders.account_headers.length > 0) {
              json.report.data.push(purchaseOrders)
            }

            // Only needed if users want the liability to be separate from other liabilities
            /*
            let committedLiabilities = Object.assign({}, purchaseOrders)
            committedLiabilities.group = 'Liability from Commitments'
            committedLiabilities.group_beginning = (parseFloat(groupSumPrevious) * -1).toFixed(2)
            committedLiabilities.group_current = (parseFloat(groupSumCurrent) * -1).toFixed(2)
            committedLiabilities.group_current_debits = (parseFloat(groupSumCurrentDebits) * -1).toFixed(2)
            committedLiabilities.group_current_credits = (parseFloat(groupSumCurrentCredits) * -1).toFixed(2)
            committedLiabilities.group_ending = (parseFloat(groupSumEnding) * -1).toFixed(2)
            committedLiabilities.account_headers = []
            // tb.push({ purchaseOrders })
            // json.report.data.push(committedLiabilities)
            */
          }

          resolve(json)
        })
      },
      generateReport () {
        this.loading = true
        this.disableReportRun = true

        if (this.reportOptions.format === 'csv') {
          this.getMultiCurrencyReportData('trialbalance')
            .then((resSorted) => {
              this.loading = false
              return this.buildTrialBalanceSummary(resSorted)
            })
            .then((resReport) => {
              return this.buildCsvData(resReport.report.data)
            })
            .then((resCsv) => {
              this.prettyJson = resCsv
              this.createNotification('Success', 'CSV is Ready. ', 'success', false, true, 'TrialBalance')
              return true
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.getMultiCurrencyReportData('trialbalance')
            .then((resSorted) => {
              return this.reportOptions.type === 'summary' ? this.buildTrialBalanceSummary(resSorted) : this.buildTrialBalance(resSorted)
            })
            .then(json => {
              this.reportJson = json
              this.prettyJson = JSON.stringify(json, null, 2)
              return this.getJsonUrl(json)
            })
            .then(resJsonUrl => {
              // PDF version of the report
              let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl
              // HTML version of the report
              let preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + resJsonUrl
              return this.getReportUrl(report)
            })
            .then(reportUrl => {
              this.loading = false
              this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
              this.storeRenderedReport('Trial Balance', 'PDF', reportUrl)
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      buildCsvData (groups) {
        if (!groups || !Array.isArray(groups)) return false
        let columnMap = {
          'Account': 'account_number',
          'Account Name': 'account_desc',
          'Beginning Balance': 'beginning',
          'Current Activity': 'current',
          'Ending Balance': 'ending',
          'Account Type': 'type'
        }

        return new Promise((resolve, reject) => {
          let trialBalanceData = []

          groups.map(grouping => {
            const tbGroup = {
              account_number: '-',
              account_desc: grouping.group,
              beginning: grouping.group_beginning,
              current: grouping.group_current,
              ending: grouping.group_ending,
              type: grouping.group
            }
            // trialBalanceData.push(tbGroup)

            grouping.account_headers.map(header => {
              let tbHeader = {
                account_number: header.account_header,
                account_desc: header.account_header_name,
                beginning: header.account_header_beginning,
                current: header.account_header_current,
                ending: header.account_header_ending,
                type: tbGroup.type
              }
              trialBalanceData.push(tbHeader)
            })
          })

          const totalSumPrevious = this.sumRecursive(groups, 'group_beginning')
          const totalSumCurrent = this.sumRecursive(groups, 'group_current')
          const totalSumEnding = this.sumRecursive(groups, 'group_ending')
          const tbTotal = {
            account_number: '---',
            account_desc: 'Grand Total',
            beginning: totalSumPrevious,
            current: totalSumCurrent,
            ending: totalSumEnding,
            type: 'TOTAL'
          }
          trialBalanceData.push(tbTotal)
          this.disableReportRun = false
          let finalCsv = this.createCsv(trialBalanceData, columnMap)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },
      async saveOptions () {
        if (this.isBusy) return
        if (this.empty_error || this.delete_error) {
          this.visible = false
          this.empty_error = false
          this.delete_error = false
          return
        }
        this.isBusy = true
        if (this.selectedReportOptions) {
          this.newAddedReport = await this.updateReportOptions({
            data: {
              report_group: this.report_group,
              report_name: this.selectedReportOptions.report_name,
              filter: { reportOptions: this.reportOptions, selectedCodes: this.selectedCodes }
            },
            id: this.selectedReportOptions.id })
        } else {
          if (!this.savereportoptions) {
            this.$notify({ title: 'Error', message: 'Report Name is required', type: 'error' })
            return
          }
          this.newAddedReport = await this.saveReportOptions({
            report_group: this.report_group,
            report_name: this.savereportoptions,
            filter: { reportOptions: this.reportOptions, selectedCodes: this.selectedCodes }
          })
        }
        this.$notify({ title: 'Success', message: 'Report Options Saved', type: 'success' })
        await this.getOptions()
        this.selectedReportOptions = this.selectedReportOptions ? this.savedReportOptions.find((s) => s.id === this.newAddedReport.id) : this.selectedReportOptions
        this.visible = false
        this.empty_error = false
        this.delete_error = false
        this.isBusy = false
        this.savereportoptions = ''
        this.selectedOption = this.newAddedReport.id
      },
      openSaveOption () {
        this.visible = true
      },
      async getOptions () {
        try {
          const savedReportOptions = await this.getReportOptions()
          this.savedReportOptions = savedReportOptions.results
        } catch (e) {
          console.log(e)
        }
      },
      async loadOptions () {
        if (this.selectedReportOptions && this.selectedReportOptions.id) {
          const loadReportOptions = await this.getReportOptions(this.selectedReportOptions.id)
          const { filter: { reportOptions, selectedCodes } } = loadReportOptions

          this.reportOptions = reportOptions
          setTimeout(() => {
            this.selectedCodes = selectedCodes
            this.reRender++
          }, 10)
        } else {
          this.empty_error = true
          this.visible = true
        }
      },
      async deleteOptions () {
        try {
          if (this.selectedReportOptions) {
            this.visible_delete = true
          } else {
            this.delete_error = true
            this.visible = true
          }
        } catch (e) {
          console.log(e)
        }
      },
      async confirmDeleteOptions () {
        try {
          await this.deleteReportOptions(this.selectedReportOptions.id)
          this.savedReportOptions = this.savedReportOptions.filter(options => options.id !== this.selectedReportOptions.id)
          this.selectedReportOptions = null
          this.selectedOption = null
          this.resetFilters()
          this.getOptions()
          this.$notify({ title: 'Success', message: 'Report Options Deleted', type: 'success' })
        } catch (e) {
          console.log(e)
        }
        this.visible_delete = false
      },
      handleSelection (value) {
        this.selectedReportOptions = value ? this.savedReportOptions.find((s) => s.id === value) : null
        if (!value) this.resetFilters()
      },
      resetFilters () {
        this.reportOptions = {
          transactionStatuses: [ 'posted', 'closed' ],
          type: 'detail',
          dates: 'datesAll',
          sort: 'account',
          status: 'all',
          format: 'pdf',
          report_currency_id: 1,
          summarizeExpenses: true,
          hideZeroDollarAccounts: true,
          includePOs: false,
          includeunposted: false,
          expenses: 'one_line'
        }
        this.selectedCodes = {
          period_start: undefined,
          period_end: undefined,
          time_posted_start: undefined,
          time_posted_end: undefined,
          effective_date_start: undefined,
          effective_date_end: undefined,
          account_id: [],
          series_id: [],
          location_id: [],
          set_id: [],
          free_field_1_id: [],
          company_id: undefined,
          production_id: [],
          source_code_id: [],
          currency_id: []
        }
      }
    },

    beforeCreate () {
    },

    created () {
      this.resetFilters()
      this.getOptions()
      // Load data to be used for validation
      this.disableReportRun = true
      this.getCompanyData()
        .then(response => {
          this.allCodes = Object.assign({}, response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.reportOptions.report_currency_id = this.allCodes.currencies.find((c) => c.is_base).id
          this.disableReportRun = false
        })
    },

    mounted () {
    },

    beforeDestroy () {
      this.resetComponent()
    }
  }

</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>



// WEBPACK FOOTER //
// src/components/Reports/TrialBalanceCustom.vue